import { postApi } from '@coconut/services/apis/utils';

export const postRating = ({ userId, questionId, score, comment, messageId }) =>
  postApi(`api/v2/students/${userId}/questions/${questionId}/rate`, {
    data: {
      score,
      comment,
      message_id: messageId,
    },
  }).then((res) => res);



// WEBPACK FOOTER //
// ./src/services/apis/rate.js